import { Box, Divider, Typography } from '@mui/material';

import {
  formatCitysprintSummaryVehicleCaption,
  getCitysprintSummaryServiceLabel,
} from '../helpers';

export function CitysprintSummaryQuoteDetails({ quote }) {
  if (!quote) {
    return null;
  }

  const vehicleName = quote.vehicle?.name ?? quote.vehicleName ?? '';
  const vehicleCaption = formatCitysprintSummaryVehicleCaption(
    quote.vehicle ?? {
      dimensions: quote.vehicleDimensions,
      maxKg: quote.vehicleMaxKg,
    }
  );
  const serviceLabel = getCitysprintSummaryServiceLabel(quote);

  if (!vehicleName && !vehicleCaption && !serviceLabel) {
    return null;
  }

  return (
    <Box sx={{ py: 1 }}>
      <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
        {vehicleName}
      </Typography>
      <Typography variant='body2' color='text.secondary'>
        {vehicleCaption}
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
        <Typography variant='body2'>{serviceLabel}</Typography>
      </Box>
      <Divider sx={{ mt: 1 }} />
    </Box>
  );
}
